import {SettingsCard} from "./SettingsCard";
import {Typography} from "antd";
import {useAppSelector, useTranslate} from "../../../hooks";
import styles from './DocumentsCard.module.scss';
import { language } from '../../../utils';

export const DocumentsCard = () => {
	const t = useTranslate([
		'firstNameText',
		'lastNameText',
		'personalInformationText',
		'companyInformationText2',
		'userAgreementText',
		'emailAddressText',
		'agreementNotFoundText',
		'RESIDENCE_PERMIT',
		'PASSPORT',
		'DRIVERS_LICENSE',
		'ID_CARD',
		'DOCUMENT_NONE',
		'documentsText',
		'identityDocument',
		'viewText',
		'dateOfContract',
	]);
	const settings = useAppSelector((state) => state.userSettings.entity);
	const user = useAppSelector((state) => state.user.entity);
	const getAgreementUrl = () => {
		switch (language) {
			case 'lt':
				return 'https://crowdpear.com/lt/naudojimosi-sutartys/';
			case 'pt':
				return 'https://crowdpear.com/pt/usage-agreements/';
			case 'ro':
				return 'https://crowdpear.com/ro/usage-agreements/';
			default:
				return 'https://crowdpear.com/usage-agreements/';
		}
	}
	return (
		<SettingsCard title={t.documentsText}>
			<div className={styles.list}>
				<div className={styles.item}>
					<Typography.Text>{t.dateOfContract}</Typography.Text>
					<span>{user?.registrationDate}</span>
				</div>
				<div className={styles.item}>
					<Typography.Text>{t.userAgreementText}</Typography.Text>
					<a target="_blank" rel="noreferrer" href={getAgreementUrl()} className={styles.download}>
						{t.viewText}
					</a>
				</div>
				<div className={styles.item}>
					<Typography.Text>{t.identityDocument}</Typography.Text>
					<span>{t[settings?.veriff_document_type || 'DOCUMENT_NONE']}</span>
				</div>
			</div>
		</SettingsCard>
	);
}

export default DocumentsCard;
